import { User } from 'firebase/auth';
import { useEffect, useState } from 'react';
import { useAuthenticationServiceContext } from '../context/contexts';

export const useAuthenticatedUser = (): User | null => {
  const authService = useAuthenticationServiceContext();
  const firstLoadAuthUser = authService.authUserResource.read();

  // This is important to have the initial state set to the first load auth use
  // otherwise it will be null for one render
  const [currentUser, setCurrentUser] = useState<User | null>(
    firstLoadAuthUser
  );

  useEffect(() => {
    const unsubscribe = authService.auth.onAuthStateChanged((user) => {
      setCurrentUser(user);
    });
    return () => unsubscribe();
  }, [authService]);

  return currentUser;
};
